import PropTypes from 'prop-types';
import { Controller, useFormContext } from 'react-hook-form';
import NumberOnlyInput from './FormInputs/NumberOnlyInput';

FormNumberField.propTypes = {
  fieldName: PropTypes.string,
  fieldAttributes: PropTypes.object,
  focusedField: PropTypes.string,
  setFocusedField: PropTypes.func,
  allowDecimal: PropTypes.bool,
};

export default function FormNumberField({ fieldName, fieldAttributes, focusedField, setFocusedField, allowDecimal }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={fieldName}
      control={control}
      render={() => (
        <NumberOnlyInput
          fieldName={fieldName}
          focusedField={focusedField}
          setFocusedField={setFocusedField}
          fieldAttributes={fieldAttributes}
          allowDecimal={allowDecimal}
        />
      )}
    />
  );
}
